<div
  class="card"
  *ngIf="prompts"
>
  <h3>Communication Prompts</h3>
  <div class="p-fluid">
    <div class="field">
      <label
        for="businessHours"
        class="block"
      >Business Hours</label>
      <textarea
        id="businessHours"
        rows="5"
        cols="30"
        pInputTextarea
        [(ngModel)]="prompts.businessHours"
        [autoResize]="true"
      ></textarea>
    </div>

    <div class="field">
      <label
        for="communications"
        class="block"
      >Communications</label>
      <textarea
        id="communications"
        rows="5"
        cols="30"
        pInputTextarea
        [(ngModel)]="prompts.communications"
        [autoResize]="true"
      ></textarea>
    </div>

    <div class="field">
      <label
        for="datadip"
        class="block"
      >Datadip Info</label>
      <textarea
        id="datadip"
        rows="5"
        cols="30"
        pInputTextarea
        [(ngModel)]="prompts.datadip"
        [autoResize]="true"
      ></textarea>
    </div>

    <div class="field">
      <label
        for="reviewsPageUrl"
        class="block"
      >Reviews Page URL</label>
      <input
        id="reviewsPageUrl"
        type="url"
        pInputText
        class="w-full"
        [(ngModel)]="prompts.reviewsPageUrl"
      />
    </div>

    <div class="field">
      <label
        for="scheduleCommunicationsRingGroups"
        class="block"
      >Schedule Communication: Ringgroups / Queues / Numbers</label>
      <textarea
        id="scheduleCommunicationsRingGroups"
        rows="5"
        cols="30"
        pInputTextarea
        [(ngModel)]="prompts.scheduleCommunicationsRingGroups"
        [autoResize]="true"
      ></textarea>
    </div>

    <div class="field">
      <label
        for="inboundCallRoutingNumbers"
        class="block"
      >Inbound Calls: Routing Numbers</label>
      <textarea
        id="inboundCallRoutingNumbers"
        rows="5"
        cols="30"
        pInputTextarea
        [(ngModel)]="prompts.inboundCallRoutingNumbers"
        [autoResize]="true"
      ></textarea>
    </div>
  </div>

  <p-button
    label="Update Prompts"
    (click)="updatePrompts()"
  ></p-button>
</div>